import { render, staticRenderFns } from "./OrgSSOModal.vue?vue&type=template&id=5a9872b7"
import script from "./OrgSSOModal.vue?vue&type=script&lang=js"
export * from "./OrgSSOModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports